<script setup lang="ts">
import { Order, OrdersnapShot } from '@/@types/order'
import { Card, CardContent } from '@/components/ui/card'

import { useForm } from '@inertiajs/vue3'
import ParticipantInfoBanner from '../../tickets-management/ParticipantInfoBanner.vue'
import TicketItem from '../../tickets-management/TicketItem.vue'
import TicketWrapper from '../../tickets-management/TicketWrapper.vue'

interface OrderShow extends Order {
    order_snap_shot: OrdersnapShot
}

defineProps<{ order: OrderShow }>()

const form = useForm({})

function removeTicket(mailingId: number, itemId?: number) {
    form.delete(`/items/${itemId}/mailings/${mailingId}`, {
        preserveState: true,
    })
}
</script>

<template>
    <Card class="border-transparent pt-6">
        <CardContent>
            <h2 class="font-sans text-2xl font-semibold text-gray-800">{{ $t('Tickets') }}</h2>
            <p class="mb-3 text-sm">{{ $t('To validate tickets, associate the participant.') }}</p>

            <div
                v-if="order.status === 'paid' || order.status === 'released'"
                v-for="orderItem in order.items"
                :key="`${orderItem.ticket_id}-new`"
                class="space-y-4"
            >
                <TicketWrapper v-for="(ticket, index) in orderItem.effective_quantity" :key="`${ticket}-${orderItem.ticket_id}`">
                    <TicketItem
                        :mailing="orderItem.mailings[index]"
                        :order-item="orderItem"
                        :status="order.status"
                        @remove-ticket="removeTicket"
                        :order="order"
                    />

                    <ParticipantInfoBanner
                        v-if="orderItem.mailings[index]"
                        :mailing="orderItem.mailings[index]"
                        :order-item="orderItem"
                        :hasActions="orderItem.mailings[index].status !== 'ticket_generated'"
                        :isAdmin="false"
                        @delete="removeTicket"
                        :status="order.status"
                        :order="order"
                    />
                </TicketWrapper>
            </div>

            <div v-else v-for="orderItem in order.items" :key="`${orderItem.ticket_id}-pending`" class="space-y-4">
                <TicketWrapper v-for="(ticket, index) in orderItem.effective_quantity" :key="`${ticket}-${orderItem.ticket_id}`">
                    <TicketItem :mailing="orderItem.mailings[index]" :order-item="orderItem" :status="order.status" :order="order" />
                </TicketWrapper>
            </div>
        </CardContent>
    </Card>
</template>
